"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = exports.Auth = void 0;

var _lruCache = _interopRequireDefault(require("lru-cache"));

var _client = _interopRequireDefault(require("./client.browser"));

var _client2 = _interopRequireDefault(require("./client.server"));

var _config = require("./config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Auth =
/*#__PURE__*/
function () {
  /**
   * Create a new auth instance
   */
  function Auth() {
    var _this = this;

    _classCallCheck(this, Auth);

    _defineProperty(this, "client", void 0);

    _defineProperty(this, "cache", new _lruCache.default(500));

    _defineProperty(this, "lastEvent", void 0);

    _defineProperty(this, "config", (0, _config.getConfig)('prod'));

    _defineProperty(this, "initialized", false);

    _defineProperty(this, "listeners", {});

    _defineProperty(this, "setEnvironment", function (env) {
      _this.config = (0, _config.getConfig)(env);
    });

    _defineProperty(this, "setConfig", function (config) {
      _this.config = (0, _config.getConfig)(_this.config.env, config);
    });

    _defineProperty(this, "initBrowser", function () {
      if (_this.client instanceof _client.default) {
        _this.client.init();
      }

      _this.initialized = true;

      _this.emit('init');
    });

    _defineProperty(this, "initServer", function (req, res) {
      if (_this.client instanceof _client2.default) {
        _this.client.init(req, res);
      }

      _this.initialized = true;

      _this.emit('init');
    });

    _defineProperty(this, "login", function (redirectTo, loginCase) {
      return _this.callBrowserClient('login', redirectTo, loginCase);
    });

    _defineProperty(this, "logout", function () {
      var storeResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var cookieOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.client.logout(storeResult, cookieOnly);
    });

    _defineProperty(this, "parseHash", function () {
      var storeResult = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.callBrowserClient('parseHash', storeResult);
    });

    _defineProperty(this, "getStoredLoginResult", function () {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return _this.callBrowserClient('getStoredLoginResult', clear);
    });

    _defineProperty(this, "isLoggedIn", function () {
      return _this.client.isLoggedIn();
    });

    _defineProperty(this, "getUser", function () {
      var forceFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.client.getUser(forceFetch);
    });

    _defineProperty(this, "getUserId", function () {
      return _this.client.getUserId();
    });

    _defineProperty(this, "getMetadata", function () {
      var forceFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var profile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'energy';
      return _this.client.getMetadata(forceFetch, profile);
    });

    _defineProperty(this, "openProfile", function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/energy';
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _this.callBrowserClient('openProfile', page, newTab);
    });

    _defineProperty(this, "fetchAuthorized", function (url, options) {
      return _this.client.fetchAuthorized(url, options);
    });

    _defineProperty(this, "getCache", function (key) {
      return _this.cache.get(key);
    });

    _defineProperty(this, "setCache", function (key, value, expires) {
      return _this.cache.set(key, value, expires);
    });

    _defineProperty(this, "log", function (level) {
      if (_this.config.log) {
        var _ref;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_ref = console)[level].apply(_ref, ['@energych/sdk-auth'].concat(args));
      }
    });

    _defineProperty(this, "callBrowserClient", function (method) {
      var _ref2;

      if (!(_this.client instanceof _client.default)) {
        var calledMethod = Array.isArray(method) ? method[1] : method;
        throw new Error("".concat(calledMethod, "() is only available in the browser"));
      }

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return (_ref2 = _this.client)[Array.isArray(method) ? method[0] : method].apply(_ref2, args);
    });

    if (typeof window !== 'undefined') {
      this.client = new _client.default(this);
    } else {
      this.client = new _client2.default(this);
    }
  }
  /**
   * Return the current auth config
   */


  _createClass(Auth, [{
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
    /**
     * Change the environment used for the ringier connect backend
     */

  }, {
    key: "emit",

    /**
     * Emit a new event
     */
    value: function emit(event) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      if (event !== 'init') {
        this.lastEvent = {
          name: event,
          data: args
        };
      }

      if (this.listeners[event]) {
        this.listeners[event].forEach(function (l) {
          return l.apply(void 0, args);
        });
      }
    }
    /**
     * Register a new event listener.
     * If the last triggered event is the same as this one, it will instantly get retriggered.
     * This allows registering the login event even after init() was called.
     */

  }, {
    key: "on",
    value: function on(event, listener) {
      if (event === 'init' && this.initialized) {
        listener();
        return this;
      }

      if (this.lastEvent && this.lastEvent.name === event) {
        listener.apply(void 0, _toConsumableArray(this.lastEvent.data));
      }

      if (!this.listeners[event]) {
        this.listeners[event] = [listener];
      } else {
        this.listeners[event].push(listener);
      }

      return this;
    }
    /**
     * Remove an event listener
     */

  }, {
    key: "off",
    value: function off(event, listener) {
      if (this.listeners[event]) {
        this.listeners[event] = this.listeners[event].filter(function (l) {
          return l !== listener;
        });
      }

      return this;
    }
    /**
     * Listen for an event once
     */

  }, {
    key: "once",
    value: function once(event, listener) {
      var _this2 = this;

      var wrappedListener = function wrappedListener() {
        _this2.off(event, wrappedListener);

        listener.apply(void 0, arguments);
      };

      this.on(event, wrappedListener);
      return this;
    }
    /**
     * Log a message
     */

  }]);

  return Auth;
}();

exports.Auth = Auth;
var auth = new Auth();
exports.auth = auth;